import { useFormContext } from 'react-hook-form';

import { type BlockedRecordCheaterFormType } from './schema';

export const useBlockedRecordCheaterForm = useFormContext<BlockedRecordCheaterFormType>;
